export interface ElectronicSignatureState {
  CPChecked: boolean;
  CodeSms: string;
  SignatureToken: string;
}

export const initialElectronicSignatureState: ElectronicSignatureState = {
  CPChecked: false,
  CodeSms: '',
  SignatureToken: '',
};
